import { Head } from "@inertiajs/react";
import MainLayout from "../../components/MainLayout";
import {
  Hero,
  CategoriesSection,
  FeaturedProductsSection,
  PromotionsSection,
  ExclusiveProductsSection,
  BrandsSection,
} from "../../components/Home";

import {
  StoreSettings,
  Product,
  Category,
  Brand,
  HeroSlide,
} from "../../types";

interface HomeProps {
  hero_slides: HeroSlide[];
  categories: Category[];
  home_category_products: Array<{ category: Category; products: Product[] }>;
  brands: Brand[];
  store_settings: StoreSettings;
  exclusive_products: any[];
  active_promotions: any[];
}

const Home = ({
  hero_slides,
  categories,
  home_category_products,
  store_settings,
  exclusive_products,
  brands,
  active_promotions,
}: HomeProps) => {
  return (
    <>
      <Head title={`${store_settings?.store_name}: Tienda Online de Tecnología y Electrónica`} />
      <Hero slides={hero_slides} />
      <CategoriesSection categories={categories} />
      {home_category_products.map((item) => (
        item.products.length > 0 && (
          <FeaturedProductsSection
            key={item.category.id}
            products={item.products}
            store_settings={store_settings}
            title={`Productos Destacados de ${item.category.name}`}
            category={item.category}
          />
        )
      ))}
      {active_promotions.map((promotion) => (
        <PromotionsSection
          key={promotion.id}
          products={promotion.products}
          promotion={promotion}
          store_settings={store_settings}
        />
      ))}
      <ExclusiveProductsSection products={exclusive_products} />
      <BrandsSection brands={brands} />
    </>
  );
};

Home.layout = (page: any) => (
  <MainLayout
    store_settings={page.props.store_settings}
    exclusiveProducts={page.props.exclusive_products}
    cart={page.props.cart}
  >
    {page}
  </MainLayout>
);

export default Home;
